// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iSwz","right":"styles_right__2QwLk"};